import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar-container" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"clip_opt-icon\"><rect width=\"1780\" height=\"960\" style=\"fill:none;\"></rect></clipPath></defs><g style=\"clip-path:url(#clip_opt-icon);\"><path class=\"icon-path filled\" d=\"M1091,148c-162.47,0-295,132.65-295,295.28V904.63c0,30,25.35,55.37,55.31,55.37s55.32-25.38,55.32-55.37V674c50.7,40.38,114.08,64.6,184.37,64.6,162.47,0,295-132.65,295-295.27S1253.47,148,1091,148m0,479.82c-101.41,0-184.37-83-184.37-184.54s83-184.55,184.37-184.55,184.37,83,184.37,184.54-83,184.55-184.37,184.55\"></path><path class=\"icon-path filled\" d=\"M1724.66,627.29h-55.33a110.7,110.7,0,0,1-110.66-110.7V258.3h166c30,0,55.34-25.37,55.34-55.36s-25.36-55.35-55.34-55.35h-166V55.34c0-30-25.36-55.34-55.34-55.34S1448,25.36,1448,55.34V516.59C1448,638.84,1547.13,738,1669.33,738h55.33c30,0,55.34-25.37,55.34-55.35s-25.36-55.36-55.34-55.36\"></path><path class=\"icon-path filled\" d=\"M369,0C164.9,0,0,164.89,0,369S164.9,738,369,738,738,573.1,738,369,573.1,0,369,0m0,627.29C226.34,627.3,110.69,511.66,110.68,369S226.31,110.7,369,110.69,627.29,226.32,627.29,369v0c.24,142.41-115,258-257.43,258.29H369\"></path><path class=\"icon-path filled\" d=\"M393.47,356.5V175.3a31.18,31.18,0,1,0-62.35,0V382L475.73,529.58a31.18,31.18,0,0,0,44.54-43.65Z\"></path></g>", 2)
const _hoisted_6 = [
  _hoisted_4
]
const _hoisted_7 = {
  key: 0,
  class: "proxy"
}
const _hoisted_8 = {
  key: 0,
  class: "profile-container"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "profile-container"
}
const _hoisted_11 = { class: "profile-initials" }
const _hoisted_12 = {
  key: 2,
  class: "profile-container"
}
const _hoisted_13 = {
  key: 0,
  class: "menu",
  ref: "navMenu"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Finish Setup ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Meeting Types")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Schedule")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Balance")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Admin Proxy")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "opt-logo nav-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleNavClick && $setup.handleNavClick(...args)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["icon opt-icon", { 'white-opt': _ctx.$route.meta.redHeader}]),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 1780 960"
          }, _hoisted_6, 2 /* CLASS */))
        ]),
        ($setup.userspace.isProxy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "PROXY"))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(["profile", { 'hide-profile': _ctx.$route.meta.hideProfile,'proxy-user': $setup.userspace.isProxy}]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleProfileClick && $setup.handleProfileClick(...args)), ["stop"]))
        }, [
          ($setup.user?.profilePic)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("img", {
                  class: "profile-pic",
                  src: $setup.user.profilePic
                }, null, 8 /* PROPS */, _hoisted_9)
              ]))
            : ($setup.user?.name?.firstName && $setup.user?.name?.lastName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString($setup.user.name.firstName[0] + $setup.user.name.lastName[0]), 1 /* TEXT */)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12))
        ], 2 /* CLASS */)
      ]),
      _createVNode($setup["hamburger"], {
        class: "hamburger-menu",
        modelValue: $setup.showMenu,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showMenu) = $event)),
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, null, 8 /* PROPS */, ["modelValue"])
    ]),
    _createVNode(_Transition, { name: "slide-in" }, {
      default: _withCtx(() => [
        ($setup.showMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "menu-options",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showMenu = false))
              }, [
                ($setup.checkSetup)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "menu-item setup-option",
                      to: "/setup"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_router_link, {
                  class: "menu-item profile-option",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_router_link, {
                  class: "menu-item availability",
                  to: "/links"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_router_link, {
                  class: "menu-item meetings-option",
                  to: "/meetings"
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_router_link, {
                  class: "menu-item my-rate",
                  to: "/balance"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_router_link, {
                  class: "menu-item profile-pic-option",
                  to: "/settings"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1 /* STABLE */
                }),
                ($setup.isAdmin && !$setup.userspace.isProxy)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      class: "menu-item",
                      to: {name: 'Admin Proxy'}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                ($setup.userspace.isProxy)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "menu-item",
                      onClick: $setup.handleUnproxy
                    }, "Un-proxy"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("span", {
                  class: "menu-item logout-option",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleLogoutClick && $setup.handleLogoutClick(...args)))
                }, "Logout ")
              ])
            ], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}